import { atom } from "jotai";

export const managersAtom = atom([]);
export const contactsAtom = atom([]);
